import { SKELETON_KEY, SKELETON_KEY_NUMBER } from './skeletonFactory';

export function skeletonTobaccoProduct() {
  return {
    id: SKELETON_KEY,
    name: SKELETON_KEY,
    cigarAmount: SKELETON_KEY_NUMBER,
    litterAmount: SKELETON_KEY_NUMBER,
    length: SKELETON_KEY_NUMBER,
    width: SKELETON_KEY_NUMBER,
    height: SKELETON_KEY_NUMBER,
    tobaccoRingPosition: SKELETON_KEY,
    masterCaseCaseAmount: SKELETON_KEY_NUMBER,
    imageUrl: SKELETON_KEY,
    readToken: SKELETON_KEY,
    nfcReadInstructions: SKELETON_KEY
  };
}
